module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_parameter":"New parameter"},"de":{"new_parameter":"Neuer Parameter"}}')
  delete Component.options._Ctor
}
